'use strict';

var React = require('react');

//Constants
var ApplicationConstants = require('../../constants/ApplicationConstants.js');
var UserTypes = ApplicationConstants.UserTypes;
var ProductIds = ApplicationConstants.ProductIds;
var YesNoValues = ApplicationConstants.YesNoValues;
import Products from '../../utils/Products.js';
//Stores
var OnlineAccessStore = require('../../stores/OnlineAccessStore.js');
import AdviserAuthorityStore from '../../stores/AdviserAuthorityStore.js';
//Components
var SectionHeader = require('../Common/SectionHeader.jsx');
var OnlineAccess = require('./OnlineAccess.jsx');
var _ = require('lodash');

var OnlineAccessSection = React.createClass({
    getStateFromStore: function(){
        return {
            onlineAccess: OnlineAccessStore.getOnlineAccess(),
            errorList: OnlineAccessStore.getErrorList(),
            adviserAuthority: AdviserAuthorityStore.getAdviserAuthorityModel()
        };
    },
    getInitialState: function () {
        return this.getStateFromStore();
    },

    componentDidMount: function () {
        OnlineAccessStore.addChangeListener(this._onChange);
    },

    componentWillUnmount: function () {
        OnlineAccessStore.removeChangeListener(this._onChange);
    },

    _onChange: function () {
        this.setState(this.getStateFromStore());
    },
    shouldHideOnlineAccess() {          
        if (Products.isAnnuity(this.props.productId)){
            return false;
        }
        else if (window.NOA.userContext.isAdviser && (this.state.adviserAuthority.isAdviserAuthorised === YesNoValues.YES || this.state.adviserAuthority.isAdviserAuthorised === '')){
            return true;
        }
        else if (window.NOA.userContext.isInvestor && window.NOA.userContext.isExisting){        
            return true;
        }
        else{
            return false;
        }
    },
    render: function () {
        var sectionNeedHelpInfo;
        if (this.props.content) {
            sectionNeedHelpInfo = this.props.content.onlineAccess[this.props.productId].sectionHelp;
            if ((this.props.productId === ProductIds.COMMINSURE || this.props.productId === ProductIds.CHALLENGER) && this.props.userType === UserTypes.INVESTOR) {
                sectionNeedHelpInfo = '';
            }
        }
        return ( 
            this.shouldHideOnlineAccess() ? null
            : (<div className="online-access-section">
                    <div className="form-step" id="online-access-section">
                        <SectionHeader focus={this.props.focus} sectionName="Online access" sectionHelpText={this.props.content.common.sectionHeaderHelp} NeedHelpInfo={sectionNeedHelpInfo} />
                        <div className="container">
                            {this.state.onlineAccess.map(function (value, index) {
                                const data = _.cloneDeep(value.data);
                                return <OnlineAccess content={this.props.content}
                                    userType={this.props.userType}
                                    investorName={(this.state.onlineAccess.length > 1) ? value.investorName : ''}
                                    data={data}
                                    fieldErrorState={value.fieldErrorState}
                                    errorList={this.state.errorList}
                                    index={index}
                                    key={index} />;
                            }.bind(this))}
                        </div>
                    </div>
                </div>
            )
        );
    }
});

module.exports = OnlineAccessSection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/OnlineAccess/OnlineAccessSection.jsx